import type { Index } from "./types";

// https://github.com/lodash/lodash/blob/master/.internal/baseSet.js
export const set = (
  object: Record<string, any>,
  path: (string | number)[],
  value: any,
) => {
  const length = path.length;
  const lastIndex = length - 1;

  let nested = object;

  for (let i = 0; i < length; i++) {
    const key = path[i];
    let newValue: any = value;

    if (i !== lastIndex) {
      const objValue = nested[key];
      newValue = isObject(objValue) ? objValue : isIndex(path[i + 1]) ? [] : {};
    }

    nested[key] = newValue;
    nested = nested[key];
  }
};

// https://github.com/lodash/lodash/blob/master/isObject.js
const isObject = (value: any): value is Record<string, any> => {
  return (
    value !== null &&
    value !== undefined &&
    (typeof value === "object" || typeof value === "function")
  );
};

const isIndex = (value: any): value is Index => {
  if (typeof value === "number") {
    return value >= 0;
  }
  if (typeof value === "string") {
    return Number.isInteger(Number(value)) && Number(value) >= 0;
  }
  return false;
};
